export { headCue } from './composer';
export type {
  FaviconPaint,
  FaviconRenderer,
  HeadCue,
  HeadCueLayer,
  SetLayerOptions,
} from './types';
